import Icon from 'flarum/common/components/Icon';
import Select from 'flarum/common/components/Select';

/**
 * One row of the profile modal: label | body | action | info icon with hint.
 */
export function field(key, label, body, action, tip) {
  return m("div", {
    className: 'Ppk2Field Ppk2Field--' + key
  }, m("div", {
    className: "Ppk2Field-label"
  }, label), m("div", {
    className: "Ppk2Field-body"
  }, body), m("div", {
    className: "Ppk2Field-action"
  }, action), m("div", {
    className: "Ppk2Field-info"
  }, tip ? m("span", {
    className: "Ppk2Tip",
    tabindex: "0"
  }, m(Icon, {
    name: "fas fa-circle-info"
  }), m("span", {
    className: "Ppk2Tip-text",
    role: "tooltip"
  }, tip)) : null));
}

/** A standalone info icon with a hint (same look as the field one). */
export function tip(text) {
  return m("span", {
    className: "Ppk2Tip",
    tabindex: "0"
  }, m(Icon, {
    name: "fas fa-circle-info"
  }), m("span", {
    className: "Ppk2Tip-text",
    role: "tooltip"
  }, text));
}
export function section(text) {
  return m("div", {
    className: "Ppk2Section"
  }, text);
}
export function locked(value, muted) {
  return m("div", {
    className: 'Ppk2Locked' + (muted ? ' Ppk2Locked--muted' : '')
  }, m(Icon, {
    name: "fas fa-lock"
  }), m("span", null, value));
}
export function note(text) {
  return m("div", {
    className: "Ppk2Note"
  }, m(Icon, {
    name: "fas fa-lock"
  }), " ", text);
}

/**
 * «Кто видит» for one field. Desktop: the usual list with an eye icon (unchanged).
 * Phone (≤ 767px, CSS): a 36px icon button showing the current value; a tap opens a compact menu.
 * Only one menu is open at a time (openVis); it is closed by a tap outside or on a tab change.
 */
let openVis = null;
export const closeVis = () => openVis = null;
export const VIS_ICON = {
  everyone: 'fas fa-globe',
  members: 'fas fa-user-check',
  club: 'fas fa-people-group',
  nobody: 'fas fa-lock'
};
export function visPicker(name, options, value, onchange, loading, title) {
  const open = openVis === name && !loading;
  const pick = k => {
    openVis = null;
    if (k !== value) onchange(k);
  };
  return m("div", {
    className: 'Ppk2VisPick' + (open ? ' open' : '')
  }, m("div", {
    className: "Ppk2Vis",
    title: title
  }, m(Icon, {
    name: value === 'nobody' ? 'fas fa-eye-slash' : 'fas fa-eye'
  }), m(Select, {
    className: "Ppk2Vis-select",
    name: name,
    options: options,
    value: value,
    disabled: loading,
    onchange: onchange
  })), m("button", {
    type: "button",
    className: 'Ppk2VisBtn Ppk2NoSwipe Ppk2VisBtn--' + value,
    title: title + ': ' + options[value],
    "aria-label": title + ': ' + options[value],
    "aria-haspopup": "listbox",
    "aria-expanded": open ? 'true' : 'false',
    disabled: loading,
    onclick: () => openVis = open ? null : name
  }, m(Icon, {
    name: VIS_ICON[value] || 'fas fa-eye'
  })), open ? [m("div", {
    className: "Ppk2VisBackdrop Ppk2NoSwipe",
    onclick: () => openVis = null
  }), m("div", {
    className: "Ppk2VisMenu Ppk2NoSwipe",
    role: "listbox",
    "aria-label": title,
    oncreate: vn => placeMenu(vn.dom),
    onkeydown: e => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        openVis = null;
      }
    }
  }, m("div", {
    className: "Ppk2VisMenu-title"
  }, title), Object.keys(options).map(k => m("button", {
    type: "button",
    role: "option",
    "aria-selected": k === value ? 'true' : 'false',
    className: 'Ppk2VisMenu-item' + (k === value ? ' active' : ''),
    onclick: () => pick(k)
  }, m(Icon, {
    name: VIS_ICON[k]
  }), m("span", null, options[k]), k === value ? m(Icon, {
    name: "fas fa-check",
    className: "Ppk2VisMenu-check"
  }) : null)))] : null);
}

/** Open the menu upwards when it would go below the sticky bottom bar / screen. */
export function placeMenu(el) {
  const r = el.getBoundingClientRect();
  const bar = document.querySelector('.Ppk2ProfilePage .Ppk2ProfileModal-footer');
  const limit = bar ? bar.getBoundingClientRect().top : window.innerHeight;
  if (r.bottom > limit - 4) el.classList.add('up');
  const active = el.querySelector('.active') || el.querySelector('button');
  if (active) active.focus({
    preventScroll: true
  });
}
flarum.reg.add('ppk2-profile', 'forum/components/Field', { field: field,tip: tip,section: section,locked: locked,note: note,closeVis: closeVis,VIS_ICON: VIS_ICON,visPicker: visPicker,placeMenu: placeMenu, });